module.exports = __webpack_public_path__ + "img/card_up_icons_1524.5dea5380.png";